<template lang="pug">
  .flex(:class="{'items-center': align}")
    .w-96.min-w-96.flex-shrink-0(:style="{'width': picWidth +'px' }" )
      //- img.w-full(src="@/assets/.svg")
      img.w-full(:src="getImgUrl(data.pic)"  v-if="data.pic")
    .py-10.px-24.text-left
      .text-main-0.leading-22.pb-8(:style="{'fontSize': fontSize +'px' }")  {{data.title}}
      span(v-html="$xss(data.content)") 
      .alertSlot
        slot(:name="custom" v-if="custom")


    
</template>

<script>


export default {
  name: 'ModalAlert',
  components: {
  },
  props: {
    fontSize:{
      type: String,
      required: false,
      default:'20',
    },
    align:{
      type: Boolean,
      default:false,
    },
    data: {
      type: Object,
      required: true,
    },
    picWidth:{
      type: String,
      required: false,
      default:'96',
    },
    custom:{
      type:String,
    }
  },
  data() {
    return {
    };
  },
  methods: {
    getImgUrl(pet) {
      let images = require.context('../assets/', false, /\.png$/)
      return images('./' + pet + ".png")
    }
  },
};
</script>

<style lang="scss" scoped>

</style>